<h2>
  {{ 'settings.tax-return-alias-subtypes' | transloco: {taxReturnAlias} }}
</h2>

<p>
  {{ 'settings.subtypes-for-tax-return-alias-type' | transloco: {taxReturnAlias} }}
  <b>{{ taxReturnTypeName }}</b>
</p>

<div class="tax-return-subtype-filters">
  <div class="tax-return-subtype-keyword-filter">
    <div class="ui left  fluid input">
      <i class="search icon tax-return-subtype-input-icon"></i>
      <input
        type="text"
        [(ngModel)]="taxReturnSubTypeSearch"
        placeholder="Search Project Form Subtypes"
      />
    </div>
  </div>
  <div class="tax-return-subtype-actions">
    @if (!isProductionMode) {
    <button
      class="ui primary background button tiny"
      (click)="addTaxReturnSubType()"
    >
      {{ 'settings.add-tax-return-alias-subtype' | transloco: {taxReturnAlias} }}
    </button>
    }
  </div>
</div>

@if (taxReturnSubTypes?.length == 0) {
<p>
  {{ 'settings.no-tax-return-alias-subtypes-found' | transloco: {taxReturnAlias} }}
</p>
} @if (taxReturnSubTypes?.length > 0) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>{{ "settings.name" | transloco }}</th>
      <th>{{ "settings.key" | transloco }}</th>
      <th>{{ "settings.status" | transloco }}</th>
      <th>{{ "settings.prior-subtype" | transloco }}</th>
      <th>{{ "settings.starting-status" | transloco }}</th>
      <th>{{ "settings.link-document-type-id" | transloco }}</th>
      @if (!isProductionMode) {
      <th></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (trs of taxReturnSubTypes | keyWord: ['subType',
    'alias']:taxReturnSubTypeSearch; track trs) {
    <tr>
      <td>{{ trs.subType }}</td>
      <td>{{ trs.alias }}</td>
      <td>{{ trs.status == 0 ? "Active" : "Inactive" }}</td>
      <td>{{ trs.priorSubType }}</td>
      <td>{{ trs.startingStatus }}</td>
      <td>{{ trs.linkDocumentTypeId }}</td>
      @if (!isProductionMode) {
      <td class="edit" align="right" (click)="editTaxReturnSubType(trs)">
        {{ "settings.edit" | transloco }}
      </td>
      }
    </tr>
    }
  </tbody>
</table>
}
